/*
 * @Author: cheesekun
 * @Date: 2021-03-18 21:15:07
 * @LastEditors: cheesekun
 * @LastEditTime: 2021-03-18 21:15:28
 * @FilePath: \dc-wsy-sign-in-activity-horizontal-front\src\directive\fixed\index.js
 */
import fixed from './fixed'

const install = function (Vue) {
  Vue.directive('fixed', fixed)
}

// if (window.Vue) {
//   window['fixed'] = fixed
//   Vue.use(install) // eslint-disable-line
// }

fixed.install = install
export default fixed
